import React, { useMemo } from "react";
import { Pencil, Trash2, Plus } from "lucide-react";
import "../Inventory/InventoryAccordion.css";

const VendorListTable = ({ vendors = [], onEdit, onDelete, onCreatePurchase }) => {
  const rows = useMemo(() => vendors || [], [vendors]);

  return (
    <div className="inv-industrial-card mt-2">
      <div className="inv-industrial-table">
        {/* Header */}
        <div
          className="inv-industrial-row inv-industrial-headrow"
          style={{
            gridTemplateColumns:
              "1.4fr 120px 140px 1.8fr 140px 140px 140px 140px 160px 160px 140px",
          }}
        >
          <div>Vendor Name</div>
          <div>Type</div>
          <div>Category</div>
          <div>Address</div>
          <div>GST</div>
          <div>Mobile</div>
          <div>State</div>
          <div>City</div>
          <div>Created On</div>
          <div>Create Purchase</div>
          <div className="inv-industrial-right">Actions</div>
        </div>

        {/* Body */}
        {rows.length === 0 ? (
          <div className="inv-industrial-empty">No vendors found.</div>
        ) : (
          rows.map((vendor) => {
            const id = vendor?.id || vendor?.vendorId;

            return (
              <div
                className="inv-industrial-row"
                key={String(id)}
                style={{
                  gridTemplateColumns:
                    "1.4fr 120px 140px 1.8fr 140px 140px 140px 140px 160px 160px 140px",
                }}
              >
                {/* Vendor Name */}
                <div className="inv-industrial-name">
                  <div className="inv-industrial-name-main">
                    {vendor?.vendorName || "—"}
                  </div>
                  <div className="inv-industrial-name-sub">
                    <span className="inv-mono">id:</span> {id || "—"}
                  </div>
                </div>

                {/* Type */}
                <div>{vendor?.vendorType || "—"}</div>

                {/* Category */}
                <div>{vendor?.vendorCategory || "—"}</div>

                {/* Address */}
                <div className="inv-industrial-cat" title={vendor?.vendorAddress || ""}>
                  {vendor?.vendorAddress || "—"}
                </div>

                {/* GST */}
                <div className="inv-mono">{vendor?.gst || "—"}</div>

                {/* Mobile */}
                <div className="inv-mono">{vendor?.mobile || "—"}</div>

                {/* State */}
                <div>{vendor?.state || "—"}</div>

                {/* City */}
                <div>{vendor?.city || "—"}</div>

                {/* Created On */}
                <div className="inv-mono">{vendor?.createdOn || "—"}</div>

                {/* Create Purchase */}
                <div>
                  <button
                    className="inv-btn inv-btn-primary"
                    style={{ padding: "8px 10px", borderRadius: 10 }}
                    onClick={() => onCreatePurchase?.(vendor)}
                    type="button"
                    title="Create Purchase"
                  >
                    <Plus size={16} />
                    Purchase
                  </button>
                </div>

                {/* Actions */}
                <div className="inv-industrial-actions-cell">
                  <button
                    className="inv-iconbtn primary"
                    title="Edit"
                    type="button"
                    onClick={() => onEdit?.(vendor)}
                  >
                    <Pencil size={16} />
                  </button>

                  <button
                    className="inv-iconbtn"
                    title="Delete"
                    type="button"
                    onClick={() => {
                      if (window.confirm("Delete this vendor?")) {
                        onDelete?.(id);
                      }
                    }}
                    style={{
                      borderColor: "rgba(239,68,68,0.25)",
                      color: "#991b1b",
                      background: "linear-gradient(135deg, rgba(239,68,68,0.10), rgba(239,68,68,0.04))",
                    }}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default VendorListTable;
